import {Pipe, PipeTransform} from '@angular/core';
import { ThingsUtil } from '../../../util/things';

@Pipe({name: 'formatThingThreshold'})
export class FormatThingThresholdPipe implements PipeTransform {

  constructor (private thingsUtil: ThingsUtil){}

  transform(value: any, type: string): string {
    let formattedThreshold = value;

    if (this.thingsUtil.isCan({type: type})) {
      formattedThreshold += '%';
    } else {
      if (value < 1) {
        formattedThreshold = 'continual';
      } else {
        formattedThreshold += ' min';
      }
    }

    return formattedThreshold;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/things/threshold/formatThingThreshold.pipe.ts